// Podtemat 5 - zadania otwarte egzaminu osmioklasisty z dzialu I.

import * as MissingFractionSummand from "../../temat10_ulamki_zwykle/E8MissingFractionSummandOpenTask";

export const registry = {
  E8MissingFractionSummandOpenTask: MissingFractionSummand,
};

export function generateTasks(options = {}) {
  return [MissingFractionSummand.generateTask(options)];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown E8 open task type: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}
